import FeatureGates from '@atlaskit/feature-gate-js-client';
import { STATSIG_FEATURE_GATES } from '../../bootstrap/statsigFeatureGates';

/**
 * Subscribe to Statsig updates for the session replay feature gate. Re-invokes when the gate value changes.
 */
export const subscribeSessionReplayGate = (onGateMaybeChanged: () => void): (() => void) => {
	return FeatureGates.onGateUpdated(STATSIG_FEATURE_GATES.SESSION_REPLAY, () => {
		onGateMaybeChanged();
	});
};
